import { z } from 'zod';
export const ZIntegrationName = z.enum([
    'yotpo',
    'hey-pongo',
    'loyoly',
    'colissimo-pickup-point',
    'atlas',
    'addingwell',
    'google',
    'facebook',
    'tiktok',
    'pinterest',
    'snapchat',
    'default-datalayer',
    'ab-tasty',
    'contentsquare',
    'elevar',
    'tag-install',
    'analyzify',
    'stape',
    'sendcloud',
    'mondial-relay',
]);
export const ZIntegrationStatus = z.enum(['draft', 'inactive', 'active', 'error']);
export const ZIntegrationCategory = z.enum(['loyalty', 'shipping', 'analytics']);
export const ZPrerequisiteCheck = z.object({
    passed: z.boolean(),
    warnings: z.array(z.string()),
    checkedAt: z.iso.datetime(),
});
export const ZBaseIntegrationConfig = z.object({
    integrationName: ZIntegrationName,
    status: ZIntegrationStatus,
    category: ZIntegrationCategory,
    installedAt: z.iso.datetime().optional(),
    updatedAt: z.iso.datetime().optional(),
    prerequisites: ZPrerequisiteCheck.optional(),
});
//# sourceMappingURL=base.js.map